import { createStyles } from '@material-ui/core/styles'
import { tokens } from '../../../assets/tokens'

// Item expandido del Sidebar del Storybook de Velora (48 px, radio 6, texto 14/600, icono 20 px).
// Se mantiene sobre el color del cliente, así que activo y hover son blancos translúcidos.
export default theme =>
  createStyles({
    root: {
      height: 48,
      margin: '4px 12px',
      width: 'calc(100% - 24px)',
      padding: '0 20px',
      borderRadius: 6,
      transition: 'all 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
      '&:hover': { backgroundColor: 'rgba(255, 255, 255, 0.12)' },
      '&.Mui-selected, &.Mui-selected:hover': { backgroundColor: 'rgba(255, 255, 255, 0.24)' }
    },
    text: {
      color: theme.textSecondary,
      fontFamily: tokens.typography.fontFamily.primary,
      fontWeight: 600,
      fontSize: 14,
      lineHeight: '16px'
    },
    active: { color: theme.textPrimary },
    icon: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minWidth: 36,
      '& svg': { width: 20, height: 20 }
    }
  })
